<template>
  <v-form
   
    ref='medicationForm'>
    <v-card
      v-for="(medication, i) in user.health.medication"
      v-bind:key="i"
      class=condCard>
      <v-text-field
        v-model="medication.name"
        label="What is the medication you are taking?"></v-text-field>
			<div
				v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 's'">
        <v-text-field
	        v-model="medication.dosage"
	        label="What is the dosage of this prescription?"></v-text-field>
        <v-select
          v-model="medication.timing"
          :items="['daily', 'weekly', 'monthly']"
          label="Timing"
          solo></v-select>
      </div>
      <v-layout
				v-else>
        <v-flex
          xs12>
          <v-text-field
          v-model="medication.dosage"
          label="What is the dosage of this prescription?"></v-text-field>
        </v-flex>
        <v-flex>
          <v-select
            v-model="medication.timing"
            :items="['daily', 'weekly', 'monthly']"
            label="Timing"
            solo></v-select>
        </v-flex>
      </v-layout>
      <v-btn
        right
        depressed
        class="right white--text"
        color="red"
        @click="remove(medication)">
        Remove
      </v-btn>
    </v-card>
    <center>
      <v-btn
        class="padded white--text"
        color="green"
        @click="addCond">
        Add medication
      </v-btn>
    </center>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
  },
  mounted () {
  },
  methods: {
    remove (item) {
      const index = this.user.health.medication.indexOf(item);
      if (index >= 0)
        this.user.health.medication.splice(index, 1);
    },
    addCond() {
      var medication = {
        name: '',
        dosage: '',
        timing: ''
      };
      this.user.health.medication.push(medication);
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
   
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
